import React, {useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import AdminEventPartnershipParagraph from "./AdminEventPartnershipParagraph";
import AdminDndList from "~/Admin/AdminDndList/AdminDndList";

const AdminEventPartnershipParagraphs = ({match, event, onChange, ...props}) => {

    const [selectedId, setSelectedId] = useState(event.hospitalities[0]?.id || 0);

    const handleOrderChanged = (data) => {
        adminHttp.put('/events/' + event.id + '/partnerships/order', {
            data: data.map(i => i.id)
        });
    }

    const handleAdd = () => {

        let body = {
            type: 'paragraphs'
        }

        adminHttp.post('/events/' + event.id + '/partnerships', body).then(res => {
            if (onChange) {
                onChange();
            }
        });
    }

    const selectedExp = event.partnership_paragraphs.find(item => item.id === selectedId);

    return (
        <div>
            <div className="card shadow-sm bg-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <h3>Partnership Paragraphs</h3>
                        </div>
                        <div className="col-4">
                            <AdminDndList
                                key={event.updated_at}
                                onChanged={handleOrderChanged}
                                onSelect={setSelectedId}
                                selected={selectedId}
                                list={event.partnership_paragraphs}
                                draggable={false}
                            />

                            {/* <button
                                onClick={handleAdd}
                                className="btn btn-primary btn-sm w-100"
                            >
                                + Add
                            </button> */}
                        </div>
                        <div className="col-8">
                            {selectedExp && <AdminEventPartnershipParagraph
                                key={selectedId}
                                onChange={onChange}
                                onDelete={onChange}
                                row={selectedExp} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventPartnershipParagraphs);
